import { NetworkTopLevelComponent } from 'Src/ng2/network/network-top-level/network-top-level.component';
import { RegentsExemptionsListContainer } from './school/lists/regents-exemptions-list/regents-exemptions-list.component';
import { HttpClientModule } from '@angular/common/http';
import { APP_INITIALIZER, ErrorHandler, NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { BrowserModule } from '@angular/platform-browser';
import { setUpLocationSync } from '@angular/router/upgrade';
import { UpgradeModule } from '@angular/upgrade/static';
import { EffectsModule } from '@ngrx/effects';
import { ActionReducer, MetaReducer, StoreModule } from '@ngrx/store';
import { ApolloModule } from 'apollo-angular';
import { HttpLinkModule } from 'apollo-angular-link-http';
import ng1AppModule from '../app/core/app.module';
import { NvPusherSocketIdInterceptor } from './shared/services/pusher/nv-pusher-interceptor.module';
import { NvDesignLibraryModule } from '../nvps-libraries/design/nv-design-library.module';
import { NvToastComponent } from '../nvps-libraries/design/nv-toast/nv-toast.component';
import { AppComponent } from './app.component';
import { NetworkContainerModule } from './network/network-container.module';
import { NetworkLeftSideNavComponent } from './network/network-left-side-nav/network-left-side-nav.component';
import { NetworkMidLevelComponent } from './network/network-mid-level/network-mid-level.component';
import { NetworkSettingsComponent } from './network/network-settings/network-settings.component';
import { NetworkSettingsModule } from './network/network-settings/network-settings.module';
import { NetworkStudentLevelComponent } from './network/network-student-level/network-student-level.component';
import { AppRoutingModule } from './routes/app-routing.module';
import { AssessmentsDataInputComponent } from './school/data-entry/assessments/assessments-data-input/assessments-data-input.component';
import { DataEntryComponent } from './school/data-entry/data-entry.component';
import { DataEntryModule } from './school/data-entry/data-entry.module';
import { DataUploadsComponent } from './school/data-uploads/data-uploads.component';
import { DataUploadsModule } from './school/data-uploads/data-uploads.module';
import { GraphDetailComponent } from './school/graph-detail/graph-detail.component';
import { GraphListComponent } from './school/graph-list/graph-list.component';
import { AcademicListContainer } from './school/lists/academic-list-v2/academic-list-v2.component';
import { AcademicListComponent } from './school/lists/academic-list/academic-list.component';
import { AttendanceListContainer } from './school/lists/attendance-list-v2/attendance-list-v2.component';
import { AttendanceListComponent } from './school/lists/attendance-list/attendance-list.component';
import { MyStudentsListComponent } from './school/lists/my-students-list/my-students-list.component';
import { PostsecondaryListContainer } from './school/lists/postsecondary-list-v2/postsecondary-list-v2.component';
import { PostsecondaryListComponent } from './school/lists/postsecondary-list/postsecondary-list.component';
import { SchoolListsModule } from './school/lists/school-lists.module';
import { StudentsListContainer } from './school/lists/students-list-v2/students-list-v2.component';
import { MidLevelDashComponent } from './school/mid-level-dashboard/mid-level-dash.component';
import { OtherToolsLeftNavComponent } from './school/school-tools/other-tools/other-tools-left-nav/other-tools-left-nav.component';
import { OtherToolsResourcesComponent } from './school/school-tools/other-tools/other-tools-resources/other-tools-resources.component';
import { OtherToolsComponent } from './school/school-tools/other-tools/other-tools.component';
import { SchoolToolsModule } from './school/school-tools/school-tools.module';
import { StudentLevelDashComponent } from './school/student-level-dashboard/student-level-dash.component';
import { StudentLevelDashModule } from './school/student-level-dashboard/student-level-dash.module';
import { TilesComponent } from './school/tiles/tiles.component';
import { BatchActionsMenuModule } from './shared/components/batch-actions-menu/batch-actions-menu.module';
import { ExitViewComponent } from './shared/components/exit-view/exit-view.component';
import { ListSummaryModule } from './shared/components/list-summary/list-summary.module';
import { NotFoundComponent } from './shared/components/not-found/not-found.component';
import { NotFoundModule } from './shared/components/not-found/not-found.module';
import { NvMatTooltipModule } from './shared/components/nv-mat-tooltip/nv-mat-tooltip.module';
import { PrivacyAndTermsComponent } from './shared/components/privacy-and-terms/privacy-and-terms.component';
import { PrivacyAndTermsModule } from './shared/components/privacy-and-terms/privacy-and-terms.module';
import { SettingsComponent } from './shared/components/settings/settings.component';
import { SettingsModule } from './shared/components/settings/settings.module';
import { DynamicComponentModule } from './shared/directives/dynamic-component/dynamic-component.module';
import { ModalsModule } from './shared/modals/modals.module';
import { HttpInterceptorModule } from './shared/services/auth/http-interceptor.module';
import { CustomErrorHandlerService } from './shared/services/custom-error-handler/custom-error-handler.service';
import { EventBus } from './shared/services/event-bus/event-bus';
import { SharedServicesModule } from './shared/services/shared.services.module';
import { ContentToolsComponent } from './shell/content-tools/content-tools.component';
import { ContentToolsModule } from './shell/content-tools/content-tools.module';
import { LoginComponent } from './shell/login/login.component';
import { LoginModule } from './shell/login/login.module';
import { PartnerPickerModule } from './shell/partner-picker/partner-picker.module';
import { SdcNavComponent } from './shell/sdc-nav/sdc-nav.component';
import { SdcNavModule } from './shell/sdc-nav/sdc-nav.module';
import { SideNavNgComponent } from './shell/side-nav/side-nav.component';
import { SideNavNgModule } from './shell/side-nav/side-nav.module';
import { ShelterListToolsModule } from './shelter/list/list-tools/shelter-list-tools.module';
import { effects, initialState, reducers } from './store';
import { LOAD_SCHOOL_SUCCESS } from './store/actions/school-actions';
import { StudentComponent } from './student/student.component';
import { StudentModule } from './student/student.module';
import { ShelterNetworkSettingsModule } from './shelter/shelter-network-settings/shelter-network-settings.module';
import { StandardLayoutModule } from './shelter/layouts/standard-layout/standard-layout.module';
import { FullScreenLayoutModule } from './shelter/layouts/full-screen-layout/full-screen-layout.module';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { SummerSchoolListContainer } from './school/lists/summer-school-list/summer-school-list.component';
import { SpinnerModalModule } from './shared/components/spinner/spinner-modal.module';

// TODO: add back commented code when migrating to ng2 routing (CM).
// import { RouterModule, UrlHandlingStrategy, UrlTree } from '@angular/router';
// import { setUpLocationSync } from '@angular/router/upgrade';
// import { routesHelpers } from './routes/routes-helpers';
// class Ng1Ng2UrlHandlingStrategy implements UrlHandlingStrategy {
//   shouldProcessUrl(url: UrlTree): boolean {
//     const routeIsNg2 = includes(routesHelpers.getRoutesUrls(), url.toString());

//     // have ng2 router process route if it is registered with ng2 (CM).
//     return routeIsNg2;
//   }
//   extract(url: UrlTree): UrlTree {
//     return url;
//   }
//   merge(newUrlPart: UrlTree, wholeUrl: UrlTree): UrlTree {
//     return newUrlPart;
//   }
// }

const initializeEventBus = EventBus => () => EventBus.initializeNgrxActionPipeline();

// MetaReducer that resets store ( EXCEPT TOGGLES ) to initialState when a new school is selected
/* istanbul ignore next */
function resetStoreState(reducer: ActionReducer<any>): ActionReducer<any> {
  return (state, action) => {
    if (action.type === LOAD_SCHOOL_SUCCESS) {
      console.warn('New School Selected: Resetting NgRx Store');

      // currentUser resolves before school, so this keeps the currentUser
      // from being overwritten on LOAD_SCHOOL_SUCCESS (JE)
      const currentUser = state.PORTAL_STORE.currentUser;
      initialState.PORTAL_STORE.currentUser = currentUser;

      state = initialState;
    }

    return reducer(state, action);
  };
}

// tslint:disable-next-line
const metaReducers: MetaReducer<any>[] = [resetStoreState];

// tslint:disable-next-line:max-classes-per-file
@NgModule({
  imports: [
    NvDesignLibraryModule,
    BrowserModule,
    FormsModule,
    UpgradeModule,
    StoreModule.forRoot({ PORTAL_STORE: reducers }, { initialState, metaReducers }),
    EffectsModule.forRoot(effects),
    // StoreDevtoolsModule.instrument(),
    HttpClientModule,
    LoginModule,
    PartnerPickerModule,
    ShelterNetworkSettingsModule,
    SideNavNgModule,
    ContentToolsModule,
    SchoolListsModule,
    SharedServicesModule,
    StudentModule,
    HttpInterceptorModule.forRoot(),
    NvPusherSocketIdInterceptor.forRoot(),
    SdcNavModule,
    ModalsModule,
    SpinnerModalModule,
    NvMatTooltipModule,
    DynamicComponentModule,
    BatchActionsMenuModule,
    ApolloModule,
    HttpLinkModule,
    ListSummaryModule,
    PrivacyAndTermsModule,
    SettingsModule,
    StudentLevelDashModule,
    NetworkContainerModule,
    DataEntryModule,
    SchoolToolsModule,
    NetworkSettingsModule,
    DataUploadsModule,
    ShelterListToolsModule,
    NotFoundModule,
    AppRoutingModule,
    StandardLayoutModule,
    FullScreenLayoutModule,
    BrowserAnimationsModule,
  ],
  declarations: [AppComponent],
  providers: [
    {
      provide: '$scope',
      useFactory: i => i.get('$rootScope'),
      deps: ['$injector'],
    },
    { provide: APP_INITIALIZER, useFactory: initializeEventBus, deps: [EventBus], multi: true },
    {
      provide: ErrorHandler,
      useClass: CustomErrorHandlerService,
    },
  ],

  // TODO: Add back once migration to NG2 is complete
  // bootstrap: [
  //   AppComponent
  // ],

  entryComponents: [
    // Components used as template value for a ui-router ng1 route need to be included here (CM).
    AppComponent,
    LoginComponent,
    MyStudentsListComponent,
    AttendanceListComponent,
    AcademicListComponent,
    PostsecondaryListComponent,
    SideNavNgComponent,
    ContentToolsComponent,
    StudentComponent,
    SdcNavComponent,
    GraphDetailComponent,
    GraphListComponent,
    ExitViewComponent,
    PrivacyAndTermsComponent,
    SettingsComponent,
    TilesComponent,
    MidLevelDashComponent,
    StudentLevelDashComponent,
    NetworkLeftSideNavComponent,
    NetworkTopLevelComponent,
    NetworkMidLevelComponent,
    NetworkStudentLevelComponent,
    DataEntryComponent,
    DataUploadsComponent,
    AssessmentsDataInputComponent,
    NvToastComponent,
    OtherToolsComponent,
    OtherToolsLeftNavComponent,
    OtherToolsResourcesComponent,
    NetworkSettingsComponent,
    AcademicListContainer,
    PostsecondaryListContainer,
    RegentsExemptionsListContainer,
    StudentsListContainer,
    AttendanceListContainer,
    NotFoundComponent,
    SummerSchoolListContainer,
  ],
})
/* istanbul ignore next */
export class AppModule {
  // We manually bootstrap the application to avoid the `injector` not being available issue that can
  // happen when an NG2 route component has NG1 dependencies (CM).
  // TOOD: Remove `ngDoBootstrap` once migration to NG2 is complete (CM).
  ngDoBootstrap(app) {
    console.warn('Bootstrapping hybrid app...');

    const upgrade = app._injector.get(UpgradeModule) as UpgradeModule;

    // Bootstrap NG2 App
    app.bootstrap(AppComponent);

    // Bootstrap NG1 App
    upgrade.bootstrap(document.documentElement, [ng1AppModule]);

    setUpLocationSync(upgrade);

    console.warn('...hybrid app bootstrapped.');
  }
}
